import {DialogContent, IconButton, Typography} from '@mui/material';
import React from 'react';
import {useDialog} from '../../hooks/useDialog/useDialog';
import {useTranslate} from '../../hooks';
import {useMockState, useThemeMode} from '@resurs-internal/rb-app-api';
import {FontIcon} from '../../components';
import {BaseDialog} from '@resurs-internal/mui';
import {MockServiceWorker} from '../../services/mockServiceWorker';
import {LocalServiceOverride} from '../../localServiceOverride';

export const DemoDialog = () => {
  const themeMode = useThemeMode();
  const translate = useTranslate();
  const mock = useMockState();
  const dialog = useDialog('demo');
  return (
    <BaseDialog
      header={translate('demo.title')}
      open={dialog.open}
      onClose={dialog.onClose}
      maxWidth={'sm'}
      actions={[
        {
          title: translate('common.cancel'),
          onClick: dialog.onClose,
        },
        {
          color: 'primary',
          title: mock.isDemoMode
            ? translate('common.disable')
            : translate('common.enable'),
          onClick: async () => {
            if (mock.isDemoMode) {
              MockServiceWorker.stop();
              mock.setMode(null);
              await LocalServiceOverride.start();
            } else {
              LocalServiceOverride.stop();
              await MockServiceWorker.start();
              mock.setMode('demo');
            }
            dialog.onClose();
          },
        },
      ]}>
      <DialogContent>
        <Typography p={2}>{translate('demo.subtitle')}</Typography>
        <IconButton
          onClick={() => {
            return themeMode.setValue?.(themeMode.isLight ? 'dark' : 'light');
          }}>
          <FontIcon icon={themeMode.isLight ? 'sun-bright' : 'moon'} />
        </IconButton>
      </DialogContent>
    </BaseDialog>
  );
};
